var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({staticClass:"primary-button",class:{ 'no-padding': _vm.noPadding },staticStyle:{"text-transform":"none !important"},attrs:{"dark":"","depressed":"","color":"#5C8DF5"}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }